import { useRef, useState } from "react";
import { useCreateApiCall } from "./useCreateApiCall";
import { API } from "aws-amplify";

const DEBOUNCE_DELAY_MS = 300;

export const useIndicators = () => {
  const { createApiCall } = useCreateApiCall();
  const [notifications, setNotifications] = useState(0);
  const [questions, setQuestions] = useState(0);
  const [referrals, setReferrals] = useState(0);
  const timeoutRef = useRef();

  const reloadIndicators = createApiCall(
    async () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // @ts-ignore
      timeoutRef.current = setTimeout(async () => {
        try {
          const result = await API.post("restApi", "/referrals", {
            body: {
              action: "newReferralCount",
            },
          });
          if (result?.error) {
            console.error(result.error);
            return;
          }
  
          setNotifications(Number(result?.notifications ?? 0));
          setQuestions(Number(result?.questions ?? 0));
          setReferrals(Number(result?.referrals ?? 0));
        } catch (error) {
          console.error(error);
        };
      }, DEBOUNCE_DELAY_MS);
    },
    (error) => console.error(error),
    true
  );

  return {
    reloadIndicators,
    notifications,
    questions,
    referrals,
  };
};
